import Count from './count';

export default class ProgressBar {
	constructor({ elements }) {
		elements.forEach((el) => {
			const { percentageFilled } = el.dataset;
			const progressBarFilled = el.querySelector('.progress-bar-filled__container');
			if (el.dataset.withAnimation) {
				const options = {
					rootMargin: '0px',
					threshold: 1.0,
				};
				const observer = new IntersectionObserver((entries) => {
					entries.forEach((entry) => {
						if (entry.intersectionRatio > 0) {
							if (!Number.isNaN(progressBarFilled) && !Number.isNaN(percentageFilled)) {
								ProgressBar.fillProgressBar(progressBarFilled, percentageFilled);
								ProgressBar.moveCounter(el, percentageFilled);
							}
							observer.unobserve(entry.target);
						}
					});
				}, options);
				observer.observe(el);
			} else {
				ProgressBar.fillProgressBar(progressBarFilled, percentageFilled, false);
			}
		});
	}

	static fillProgressBar(filledProgressBar, filledPercentage, withAnimation = true) {
		const progressBarFilled = filledProgressBar;
		progressBarFilled.style.width = `${filledPercentage}%`;
		progressBarFilled.innerHTML = `<span class="progress ${
			withAnimation ? 'progress--animated' : ''
		}"></span>`;
	}

	static moveCounter(el, filledPercentage) {
		const progressCounter = el.querySelector('.progress-counter');
		if (filledPercentage < 100) {
			progressCounter.style.left = `${filledPercentage}%`;
		} else {
			progressCounter.style.left = '100%';
		}
		if (el.querySelectorAll('[data-count]').length > 0) {
			// eslint-disable-next-line no-new
			new Count({ elements: document.querySelectorAll('[data-count]') });
		}
	}
}
